// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Z471","col":"styles_col__4JIdX"};